import { deepmerge } from '@mui/utils';
import { defaultTheme } from 'react-admin';
import { createTheme } from '@mui/material/styles';
import { touchComponents } from './touchTheme';

const baseTheme = {
    components: {
        ...touchComponents,
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    transition: 'all 0.3s ease'
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    'input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 100px inherit inset !important',
                        transition: 'background-color 50000s ease-in-out 0s',
                        backgroundColor: 'inherit !important',
                        WebkitTextFillColor: 'inherit',
                        caretColor: 'inherit'
                    },
                    'input:autofill': {
                        backgroundColor: 'inherit !important',
                        MozAutofillBackground: 'inherit !important'
                    }
                }
            }
        }
    }
};

export const lightTheme = createTheme(
    deepmerge(
        defaultTheme,
        deepmerge(baseTheme, {
            palette: {
                mode: 'light',
                background: {
                    default: '#f5f5f5',
                    paper: '#eeeeee',
                },
                primary: {
                    main: '#2F68AC',
                },
                secondary: {
                    main: '#26a6ed',
                },
                text: {
                    primary: '#000000', // Ensure black text
                },
                action: {
                    hover: 'rgba(0, 0, 0, 0.05)', // Set hover background color
                },
            },
            components: {
                MuiAppBar: {
                    styleOverrides: {
                        root: {
                            backgroundColor: '#f5f5f5', // Same as background color
                            color: '#000000', // Black text
                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Overlaid shadow effect
                        },
                    },
                },
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundImage: 'none', // Remove default gradient
                        },
                    },
                },
                MuiInputBase: {
                    styleOverrides: {
                        root: {
                            'input:-webkit-autofill': {
                                WebkitBoxShadow: '0 0 0 100px #e6e6e6 inset !important',
                                backgroundColor: '#e6e6e6 !important'
                            },
                            'input:autofill': {
                                backgroundColor: '#e6e6e6 !important',
                                MozAutofillBackground: '#e6e6e6 !important'
                            }
                        }
                    }
                },
                MuiButton: {
                    styleOverrides: {
                        outlinedPrimary: {
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            color: '#000000',
                        },
                        outlinedSecondary: {
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            color: '#000000',
                        },
                    },
                },
            }
        })
    )
);

export const darkTheme = createTheme(
    deepmerge(
        defaultTheme,
        deepmerge(baseTheme, {
            palette: {
                mode: 'dark',
                background: {
                    default: '#202124',
                    paper: '#1b1b1c',
                },
                primary: {
                    main: '#26a6ed',
                },
                secondary: {
                    main: '#90caf9',
                },
                text: {
                    primary: '#f5f5f5',
                    secondary: '#b0b0b0',
                },
                action: {
                    hover: 'rgba(255, 255, 255, 0.04)', // Set hover background color
                },
            },
            components: {
                MuiAppBar: {
                    styleOverrides: {
                        root: {
                            backgroundColor: '#202124', // Same as background color
                            color: '#f5f5f5', // Black text
                            backgroundImage: 'None',
                        },
                    },
                },
                MuiCard: {
                    styleOverrides: {
                        root: {
                            backgroundColor: '#222325 !important', // Ensures it matches `paper`
                            color: '#f5f5f5 !important', // Ensures white text
                        },
                    },
                },
                MuiCardContent: {
                    styleOverrides: {
                        root: {
                            backgroundColor: 'inherit', // Makes sure it inherits from Card/Paper
                            color: '#f5f5f5 !important', // Ensures text remains white
                        },
                    },
                },
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundImage: 'none', // Remove default gradient
                        },
                    },
                },
                MuiInputBase: {
                    styleOverrides: {
                        root: {
                            'input:-webkit-autofill': {
                                WebkitBoxShadow: '0 0 0 100px #202124 inset !important',
                                backgroundColor: '#202124 !important'
                            },
                            'input:autofill': {
                                backgroundColor: '#202124 !important',
                                MozAutofillBackground: '#202124 !important'
                            }
                        }
                    }
                },
                MuiButton: {
                    styleOverrides: {
                        outlinedPrimary: {
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            color: '#f5f5f5',
                        },
                        outlinedSecondary: {
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            color: '#f5f5f5',
                        },
                    },
                },
            }
        })
    )
);